import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    walletBalance: 0,
    unreadMessages: 0
  },

  mutations: {
    SET_WALLET_BALANCE(state, balance) {
      state.walletBalance = Number(balance) || 0
    },

    SET_UNREAD_MESSAGES(state, count) {
      state.unreadMessages = Number(count) || 0
    },
  
    CLEAR_UNREAD_MESSAGES(state) {
      state.unreadMessages = 0
    }
  },

  actions: {
    setWalletBalance({ commit }, balance) {
      commit("SET_WALLET_BALANCE", balance)
      localStorage.setItem("user_balance", balance)
    },

    loadWalletBalance({ commit }) {
      const balance = localStorage.getItem("user_balance")
      if (balance !== null) {
        commit("SET_WALLET_BALANCE", balance)
      }
    }
  },

  getters: {
    canViewPhone: (state) => state.walletBalance > 0,
    unreadMessages: state => state.unreadMessages
  }
})

